export const GROUP_MANAGEMENT_URLS = {
  GET_SINGLE_GROUP_ADMIN_LAVEL: '/group-management/:id',
  GET_GROUP_ADMIN_LEVELS_MAPPINGS: '/group-management',
  CREATE_GROUP_ADMIN_LAVEL: '/group-management',
  UPDATE_GROUP_ADMIN_LAVEL: '/group-management/:id',
  DELETE_GROUP_ADMIN_LAVEL: '/group-management/:id'
};
